import React, {Component} from "react";
import {LocalForm, Errors, Control} from "react-redux-form";
import {isEmail, required} from "../field_validations";

export default class RegisterValidate extends Component{
	render(){
		//const required = (val) => val && val.length;
		const {register} = this.props;
		return (
			<div className="content">
				<p className="is-size-5 has-text-centered">Registro</p>
				{register.state === 'open' ?
					<p className="has-text-centered">
						Ingresa tu e-mail para comenzar.
					</p>:''}


				{register.error && <p className="has-text-centered help is-danger">{register.error}</p>}
				{register.message && <p className="has-text-centered help is-success">{register.message}</p>}

				{register.state === 'open' ?
					<LocalForm onSubmit={(val) => this._handleSubmit(val)}>
						<div className="field">
							<div className="control has-icon has-icon-left">
								<Control.text type="email" model=".email" className="input" placeholder="E-mail" autoFocus errors={{required, isEmail}} validateOn="change" />
								<span className="icon is-small is-left"><i className={`fa fa-envelope`}/></span>
							</div>
							<Errors className="help is-danger" model=".email" show="touched" messages={{
								required: 'Debes ingresar tu e-mail',
								isEmail: 'El email es inválido'
							}}/>
						</div>

						<div className="level">
							<div className="level-left">
								<div className="level-item">
									<button type="button" onClick={() => this.props.history.push('/')} className="button is-small">Regresar a iniciar sesión</button>
								</div>
							</div>
							<div className="level-right">
								<div className="level-item">
									<button type="submit" className="button is-black">
										<span>Validar</span>
									</button>
								</div>
							</div>
						</div>
					</LocalForm>:<h1 className="title is-1 has-text-black has-text-centered">Registro cerrado</h1>}
			</div>
		)
	}

	_handleSubmit(values) {
		//console.log('email===>', values.email);
		this.props.validateEmail(values.email);
	}
}


// WEBPACK FOOTER //
// ./src/elements/register/registerValidate.jsx